import Icon from '@/components/ui/AppIcon';

const ConservationBanner = () => {
  return (
    <div style={{ backgroundColor: '#0F2234', borderLeft: '4px solid #6FD3E0', border: '1px solid rgba(111,211,224,0.15)', borderLeftWidth: '4px' }} className="rounded-xl p-6">
      <div className="flex items-start space-x-4">
        <div className="flex-shrink-0">
          <div style={{ backgroundColor: '#6FD3E0' }} className="w-12 h-12 rounded-full flex items-center justify-center">
            <Icon name="ShieldCheckIcon" size={24} style={{ color: '#0B1622' }} />
          </div>
        </div>
        <div className="flex-1">
          <h3 style={{ color: '#EAF4F8' }} className="text-lg font-headline font-bold mb-2">
            Marine Conservation Commitment
          </h3>
          <p style={{ color: '#C8DDE6' }} className="text-sm leading-relaxed mb-3">
            Cyprus waters are home to protected species and marine reserves. As responsible divers, we must respect marine life, maintain safe distances, and never touch or disturb underwater creatures. Together, we can preserve this underwater environment for future generations.
          </p>
          <div className="flex flex-wrap gap-2">
            <span style={{ backgroundColor: 'rgba(34,197,94,0.1)', color: '#4ade80', border: '1px solid rgba(34,197,94,0.2)' }} className="inline-flex items-center space-x-1 px-3 py-1 rounded-full text-xs font-medium">
              <Icon name="CheckCircleIcon" size={14} />
              <span>Look but don&apos;t touch</span>
            </span>
            <span style={{ backgroundColor: 'rgba(34,197,94,0.1)', color: '#4ade80', border: '1px solid rgba(34,197,94,0.2)' }} className="inline-flex items-center space-x-1 px-3 py-1 rounded-full text-xs font-medium">
              <Icon name="CheckCircleIcon" size={14} />
              <span>Respect marine reserves</span>
            </span>
            <span style={{ backgroundColor: 'rgba(34,197,94,0.1)', color: '#4ade80', border: '1px solid rgba(34,197,94,0.2)' }} className="inline-flex items-center space-x-1 px-3 py-1 rounded-full text-xs font-medium">
              <Icon name="CheckCircleIcon" size={14} />
              <span>Report sightings</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConservationBanner;